<!-- <p>Ja s'ha acabat la petició de trasllat {{trasllat | json}}</p>
<p>{{trasllat.alumne.dataNaixement | date:'fullDate'}}</p> -->
<form #formulari="ngForm">
    <div *ngIf="trasllat.estat==1">
        <p i18n="@@403e70ada556258b678baf86edc72ddba5e7c3ea">La sol·licitud de trasllat s'ha realitzat correctament i es troba pendent de revisió.</p>
        <p i18n>Comprova que reps uns correu electrònic a l'adreça que ens has indicat. </p>
        <p i18n="@@72ef1e8e3955554a1a355266781df6cc4b8d2373">En cas contrari posa't en contacte amb nosaltres sga@udg.edu</p>
    </div>
    <p *ngIf="trasllat.estat==2" i18n="@@e0420f05c77cbd0ac4444076e17f3904158843ca">La sol·licitud de trasllat s'ha realitzat correctament i es troba pendent de resolució.</p>
    <p *ngIf="trasllat.estat==4" i18n="@@223d958ca4708b4f06df24e326b8978ecced55f1">La sol·licitud de trasllat ha estat acceptada a tràmit.</p>
    <p *ngIf="trasllat.estat==8" i18n="@@363b00254159b8a9470e943ab9ab9e49e2f5a233">La sol·licitud de trasllat ha estat denegada.</p>
    <p *ngIf="trasllat.estat==16" i18n="@@861d4ac7d56748475fe2ea72faa9a7c736e43033">La sol·licitud de trasllat ha estat anul·lada.</p>
    <p *ngIf="trasllat.estat==32" i18n="@@a928045aed90807ca994d1b6fae2ed5dc046b674">La sol·licitud de trasllat ha estat preacceptada a tràmit i està pendent de pagar l'import.</p>
    <p *ngIf="trasllat.estat==128" i18n="@@9ed1fd3c489b3959c6b644fd10f90e2badc55092">La sol·licitud de trasllat es troba en tràmit.</p>
    <p *ngIf="trasllat.estat==256" i18n="@@f0a92d591776d1208adba49f129d35794e3fa28f">S'ha renunciat a la sol·licitud de trasllat.</p>
    <div class="pre-controls-right" *ngIf="trasllat.potModificar">
        <button mat-raised-button matStepperPrevious i18n>Torna</button>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/confirmacio/confirmacio.component.html